<div class="slideshow">
  <div #swiperRoot class="swiper hero-swiper">
    <div class="swiper-wrapper">
      <section
        *ngFor="let slide of slides"
        class="swiper-slide hero-slide"
        [style.background-image]="slideBackground(slide)"
      >
        <div class="overlay"></div>

        <div class="slideshow-inner">
          <div class="slide-content">
            <p class="slide-subtitle" *ngIf="slide.subtitle">
              {{ slide.subtitle }}
            </p>

            <h1 class="slide-title">
              {{ slide.title }}
            </h1>

            <p class="slide-body" *ngIf="slide.body">
              {{ slide.body }}
            </p>

            <div class="slide-actions" *ngIf="slide.ctaText && slide.ctaHref">
              <a
                *ngIf="isInternalLink(slide.ctaHref); else externalCta"
                mat-raised-button
                color="primary"
                [routerLink]="slide.ctaHref"
              >
                <mat-icon>arrow_forward</mat-icon>
                {{ slide.ctaText }}
              </a>

              <ng-template #externalCta>
                <a
                mat-raised-button
                color="primary"
                [href]="slide.ctaHref"
                >
                  <mat-icon>arrow_forward</mat-icon>
                  {{ slide.ctaText }}
                </a>
              </ng-template>
            </div>
          </div>
        </div>
      </section>
    </div>

    <button
      #prevEl
      mat-icon-button
      class="nav nav-left"
      aria-label="Previous slide"
      type="button"
      (click)="previousSlide()"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button
      #nextEl
      mat-icon-button
      class="nav nav-right"
      aria-label="Next slide"
      type="button"
      (click)="nextSlide()"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>

    <div #paginationEl class="hero-swiper-pagination"></div>
  </div>
</div>
